import "./MethodDebugger.moduleRenamed.css";

export const debug = "MethodDebugger-module__debug___qSRAO";
export const script = "MethodDebugger-module__script___kSBs8";
export const tips = "MethodDebugger-module__tips___c-mRR";
export const showLog = "MethodDebugger-module__showLog___M78Gv";
export const title = "MethodDebugger-module__title___bCwEi";
export const toolTip = "MethodDebugger-module__toolTip___kaMGc";
export const debugBtn = "MethodDebugger-module__debugBtn___8qMVw";
export const updateSchemaTip = "MethodDebugger-module__updateSchemaTip___SemHY";
export const updateSchema = "MethodDebugger-module__updateSchema___SU1qZ";
export const processesBtn = "MethodDebugger-module__processesBtn___OoRDL";

export default {
  debug: "MethodDebugger-module__debug___qSRAO",
  script: "MethodDebugger-module__script___kSBs8",
  tips: "MethodDebugger-module__tips___c-mRR",
  showLog: "MethodDebugger-module__showLog___M78Gv",
  title: "MethodDebugger-module__title___bCwEi",
  toolTip: "MethodDebugger-module__toolTip___kaMGc",
  debugBtn: "MethodDebugger-module__debugBtn___8qMVw",
  updateSchemaTip: "MethodDebugger-module__updateSchemaTip___SemHY",
  updateSchema: "MethodDebugger-module__updateSchema___SU1qZ",
  processesBtn: "MethodDebugger-module__processesBtn___OoRDL",
};